export const config = {
    rest_url: 'https://api.realworld.io/api/'
};
